import { IconName, spriteUrl } from "assets/sprites/icons.generated"
import { createSpriteIconComponent, SpriteIconProps } from "src/components/generic/SpriteIcon"

export type { IconName }

export type IconProps = SpriteIconProps<IconName>

export const Icon = createSpriteIconComponent<IconName>(spriteUrl)
